/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EvaluationRangeOpenApi } from './evaluationRangeOpenApi';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface Test { 
    id: number;
    uuid: string;
    name: string;
    title: string;
    minAge: number;
    maxAge: number;
    age: number;
    etag: string;
    shortTitle: string;
    color: string;
    productCodename: string;
    version: string;
    ranges: EvaluationRangeOpenApi;
}